import script from "./changePassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./changePassword.vue?vue&type=script&setup=true&lang=ts"

import "./changePassword.vue?vue&type=style&index=0&id=51959a04&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51959a04"]])

export default __exports__